module.exports = __webpack_public_path__ + "static/img/tojoin-bg.65fd83a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/test-drive/tojoin-bg.jpg
// module id = O7/L
// module chunks = 1